var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 218.1 195.1",
    style: {
      enableBackground: "new 0 0 218.1 195.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.1,117.5l-40.1,73.8c-0.9,1.7-2.4,2.9-4.2,3.4c-1.8,0.5-3.7,0.3-5.3-0.6l-62.6-34.6l0-29.2l3.2-5.9 l13.3,2.7l-11.5,21.1l60,33.1l29.9-55l-43.1-23.8l3.3-16.6L210.1,117.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.4,95.9 116.4,95.9 116.4,95.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M216.5,105.6l-4,7.3l-58.7-32.5l3.1-15.8l56.8,31.4C217.1,97.8,218.4,102.1,216.5,105.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.5,80.2c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.1,0,0.1-0.1C137.8,80.1,137.7,80.1,137.5,80.2z M137.5,80.2 c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.1,0,0.1-0.1C137.8,80.1,137.7,80.1,137.5,80.2z M137.5,80.2c0.1,0,0.2-0.1,0.3-0.1 c0.1,0,0.1,0,0.1-0.1C137.8,80.1,137.7,80.1,137.5,80.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.5,136.4c0,10.9-8.7,19.8-19.6,19.8c-10.8,0-19.6-8.8-19.6-19.7c0-2.2,0.4-4.4,1-6.4l2.1,0.4 c0.8,0.2,1.6,0.2,2.4,0.2c2.4,0,4.7-0.7,6.8-2.1c2.7-1.8,4.6-4.6,5.2-7.9l0.8-4.1c0.4,0,0.8-0.1,1.2-0.1 C158.7,116.7,167.5,125.5,167.5,136.4z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "84,89.1 84,89.2 83.6,89.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.2,15.6L77.4,0.1c-1.8-0.4-3.7,0-5.3,1.1c-1.6,1.1-2.6,2.7-3,4.5l-0.2,0.8l5.4,1.1 c2.6,0.5,4.9,2.1,6.4,4.3c1.5,2.3,2,5,1.5,7.6c-0.5,2.7-2,5-4.3,6.5c-2.2,1.5-4.9,2-7.6,1.5L65,26.4l-4.6,23.2l13.2,0L76,37.5 l67.1,13.5l-0.2,1l-0.5,2.6l-0.5,2.6l-1.5,7.3l-0.6,2.8l-0.6,3.2l-1.3,6.5l-0.6,3.2h0l-0.6,2.8l-2.2,11.1l-3.6,18.2l-7.9-1.6 l-13.3-2.7l-2.7-0.5l-2.7-0.5l-6.7-1.3l0,12.7l0.5,0.1l2.7,0.5l2.7,0.5l13.3,2.7l15,3l0.7,0.1c3.8,0.8,7.5-1.7,8.3-5.6l0.4-1.9 l3.6-18.1l7.5-37.9l0.5-2.7l0.5-2.7l3.8-19.4L91.2,23.9l1-5.2L158.1,32l1.6-8.1C160.5,20.1,158,16.3,154.2,15.6z M137.8,80.1 c-0.1,0-0.2,0.1-0.3,0.1c0.1,0,0.3-0.1,0.4-0.1C137.9,80,137.8,80.1,137.8,80.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.4,95.9 116.4,95.9 116.4,95.9  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.9,80c-0.1,0-0.1,0-0.1,0.1c-0.1,0-0.2,0.1-0.3,0.1C137.7,80.1,137.8,80.1,137.9,80z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "84,89.1 84,89.2 83.6,89.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "116.4,95.9 116.4,95.9 116.4,95.9  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "84,89.1 84,89.2 83.6,89.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.3,62.1L120,78.3v0l-3.6,17.5l0,0l0,0l-2.7-0.6l-2.7-0.5L97.6,92l0-30.1c0-1.9-0.4-3.7-1.2-5.4L123.3,62.1 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.4,95.9 116.4,95.9 116.4,95.9  "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.5,139.9l0-5.4V129l0-6.3l0-2.7v-2.7l0-12.7l0-13.7v0l0-15.4l-6.7,0l-17.2,0l-13.2,0H50l-25.8,0l0-5.3 l26.9,0h2.7l2.7,0l13.2,0l17.2,0l5.6,0l0-8.3c0-1.9-0.7-3.7-2.1-5c-0.2-0.2-0.5-0.4-0.7-0.6c-1.2-0.9-2.7-1.5-4.3-1.4l-12.8,0 l-13.2,0h-2.7l-2.7,0L7,55c-3.9,0-7,3.2-7,7.1v0.8l5.5,0c0,0,0,0,0,0c2.7,0,5.2,1.1,7.1,3c1.9,1.9,2.9,4.5,3,7.2 c0,2.7-1,5.3-2.9,7.2c-1.9,1.9-4.4,3-7.1,3l-5.5,0l0.1,76.7c0,1.9,0.7,3.7,2.1,5c1.3,1.3,3.1,2.1,5,2.1h0l78.3-0.1 c1.9,0,3.6-0.7,5-2.1c0.7-0.7,1.2-1.5,1.6-2.4c0.3-0.8,0.5-1.7,0.5-2.6v-3.1L92.5,139.9z M15.7,151.9l-0.1-57.4l30.7,0l2.7,0h2.7 l13.2,0l14,0l0,7.5l0,12.7v2.7l0,2.7l0,31.8L15.7,151.9z M84,89.2l-0.4-0.1L84,89.2L84,89.2z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.6,89.1l0.4,0.1v-0.1H83.6z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "68.4,139.4 25.5,139.5 46.4,109.2 47.2,108.1 51,113.8  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProShield);
export default __webpack_public_path__ + "static/media/ProShield.927b187b49e0f15822ad14fd73dd2b6c.svg";
export { ForwardRef as ReactComponent };